import styled from 'styled-components';

export const SectionTitle = styled.p`
  font-size: 27px;
  margin-left: 30px;
  color: #a5a5a5;
  margin-top: 20px;
`;
